import {BehaviorSubject, combineLatest, Observable} from 'rxjs';

import {map, switchMap} from 'rxjs/operators';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {DataService} from '../services/data.service';
import {Budget} from '../interfaces';
import {MaterialItem} from './interfaces/material-item';
import {calculateOrderMaterialItemValue} from '../order/components/OrderAddUtils';
import {Order} from '../interfaces/order';
import {OrderService} from '../services/orders.service';
import {MaterialsBalanceTableComponent} from './components/materials-balance-table/materials-balance-table.component';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {ProjectNrPipe} from '../shared/pipes/project-nr.pipe';
import {MatIconButton} from '@angular/material/button';



@Component({
    selector: 'app-materials-list',
    templateUrl: './materials-list.component.html',
    styleUrls: ['./materials-list.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        MatCardModule,
        MatIconModule,
        ProjectNrPipe,
        MaterialsBalanceTableComponent,
        MatIconButton
    ]
})
export class MaterialsListComponent implements OnInit, OnDestroy {

    public triggerRefresh = new BehaviorSubject<boolean>(false);
    public budgetId = '';
    public budget$: Observable<Budget>;
    public materialTotalCost: number;
    private materialList = new BehaviorSubject<Order[]>([]);
    private subscription;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
        private orderService: OrderService) {
    }

    ngOnInit() {
        this.subscription = combineLatest([
            this.route.paramMap,
            this.triggerRefresh
        ]).pipe(
            switchMap(([params, trigger]) => {
                this.budgetId = params.get('budgetId');

                this.budget$ = this.dataService.getSimpleBudget(this.budgetId);

                return this.orderService.getOrdersByBudget(this.budgetId);
            }))
            .subscribe(this.materialList);


        this.materialList.pipe(
            map((orders: Order[]) => {

                const flatMat: MaterialItem[] = [];

                for (const order of orders) {
                    for (const item of order.items) {
                        if (item.budget.id === this.budgetId) {
                            const el: MaterialItem = {
                                item,
                                orderId: order.id,
                                orderNr: order.orderNr,
                                date: order.date as Date,
                                deleted: order.deleted,
                                author: order.author.displayName,
                                vendor: order.vendor.name,
                                total: calculateOrderMaterialItemValue(item.costEach, item.quantity, item.discount)
                            };
                            flatMat.push(el);
                        }
                    }
                }
                return flatMat;
            })).subscribe(flatMat => {
            this.materialTotalCost = flatMat.reduce((a, b) => a + b.total, 0);
        });
    }

    public refresh = () => {
        this.triggerRefresh.next(true);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}